/**
 * NodeMutationManager merges attrs as `{ ...current, ...incoming }` and only
 * removes a key when the incoming value is `undefined`. Omitting the key
 * (via `delete`) leaves `authoredPlacement: true` on the node.
 */
export const withAuthoredPlacementCleared = (
  attrs: Record<string, unknown>,
): Record<string, unknown> => {
  if (attrs.authoredPlacement !== true) return attrs;
  return { ...attrs, authoredPlacement: undefined };
};

export const omitAuthoredPlacement = (
  attrs: Record<string, unknown>,
): Record<string, unknown> => {
  if (attrs.authoredPlacement !== true) return attrs;
  const next = { ...attrs };
  delete next.authoredPlacement;
  return next;
};
